module.exports = __webpack_public_path__ + "img/7ac6f8e.png";